import Snackbar from "@material-ui/core/Snackbar";
import React from "react";
import MuiAlert from "@material-ui/lab/Alert";

let Element = props => {
    let handleClose = (e, r) => {
        if (r !== "clickaway") {
            props.setState({
                open: false,
                message: "",
            })
        }
    }

    return (
        <Snackbar open={props.open}
                  onClose={handleClose}
                  anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                  autoHideDuration={Number(process.env.REACT_APP_NOTIFICATION_HIDE_TIME)}
        >
            <MuiAlert lang={props.lang}
                      severity={props.severity}
                      onClose={handleClose}
                      elevation={6}
                      variant="filled">
                {props.message}
            </MuiAlert>
        </Snackbar>
    )
}

export default Element